import { Pipe, PipeTransform } from '@angular/core';
import { FiltersService } from '../services/filters.service';
import {translations} from 'compob2b-libs'

@Pipe({
    name: 'render',
    standalone: false
})
export class RenderPipe implements PipeTransform {
  transform(row: any, key: string): string {
    const split = key.split('.');

    let value = FiltersService.getPath(split, row);

    if (value === false) {
      value = '';
    }
    if (value === true) {
      value = translations.yes.toLowerCase();
    }

    return value;

  }
}
